export default "__VITE_ASSET__BZPErHy7__"